import { bankAccountService } from 'hq/services';
import { useMutation } from 'react-query';

export const useRejectPendingBankAccount = () => {
  const mutationFn = async (id: string) => await bankAccountService.rejectPendingBankAccounts(id);

  return useMutation(mutationFn);
};
